// extracted by mini-css-extract-plugin
module.exports = {"favoritesList":"CFavorites_favoritesList","forceOpenSection":"CFavorites_forceOpenSection"};